import { useMutation, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { deleteLibrary } from "../api/libraryService";
export var useLibraryDeleteMutation = function (onSuccess, onError) {
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (libraryId) { return deleteLibrary(kyInstance, libraryId); },
        onSuccess: function () {
            queryClient.invalidateQueries({ queryKey: ["libraries"] });
            onSuccess();
        },
        onError: onError,
    });
};
